import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLogin({ onLogin }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const res = await axios.post(`${API}/admin/auth`, { username, password });
      if (onLogin) onLogin(res.data);
      // Force a hard nav so AuthProvider re-checks
      window.location.href = "/";
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Sign-in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(1200px 600px at 20% 10%, rgba(120,200,255,0.10), transparent 60%), radial-gradient(900px 500px at 90% 90%, rgba(180,120,255,0.10), transparent 60%), #07071a",
        color: "#e8e8ff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, -apple-system, Segoe UI, sans-serif",
        padding: "24px",
      }}
    >
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        style={{
          width: "100%",
          maxWidth: 380,
          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(120,200,255,0.18)",
          borderRadius: 18,
          padding: 28,
          backdropFilter: "blur(18px)",
          boxShadow: "0 30px 80px rgba(0,0,0,0.45)",
        }}
      >
        <div style={{ fontSize: 11, letterSpacing: 2, color: "#7cf", opacity: 0.85 }}>
          OMEGA · RESTRICTED
        </div>
        <h1 style={{ margin: "6px 0 4px", fontSize: 26, fontWeight: 700 }}>
          Admin sign-in
        </h1>
        <p style={{ margin: "0 0 22px", color: "#9aa", fontSize: 13 }}>
          Dedicated route for administrator access.
        </p>

        <label style={{ display: "block", fontSize: 12, color: "#aab", marginBottom: 6 }}>
          Username
        </label>
        <input
          data-testid="admin-login-username"
          type="text"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
          style={inputStyle}
        />

        <label style={{ display: "block", fontSize: 12, color: "#aab", margin: "14px 0 6px" }}>
          Password
        </label>
        <input
          data-testid="admin-login-password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
        />

        {err && (
          <div
            data-testid="admin-login-error"
            style={{
              marginTop: 14,
              padding: "10px 12px",
              background: "rgba(255,80,80,0.10)",
              border: "1px solid rgba(255,80,80,0.30)",
              borderRadius: 10,
              color: "#ffb4b4",
              fontSize: 13,
            }}
          >
            {err}
          </div>
        )}

        {process.env.NODE_ENV === "development" && (
          <button
            type="button"
            disabled={busy}
            onClick={() => {
              // Prefill from env-documented defaults so the dev can verify and
              // submit manually. Never auto-submits credentials.
              setUsername("admin");
              setErr("");
            }}
            style={{
              marginTop: 14,
              width: "100%",
              padding: "10px 16px",
              borderRadius: 12,
              border: "1px dashed rgba(167,139,250,0.5)",
              background: "rgba(167,139,250,0.08)",
              color: "#a78bfa",
              fontWeight: 600,
              fontSize: 13,
              cursor: "pointer",
              letterSpacing: 0.3,
            }}
          >
            ⚡ Prefill dev username
          </button>
        )}

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={busy || !username || !password}
          style={{
            marginTop: 18,
            width: "100%",
            padding: "12px 16px",
            borderRadius: 12,
            border: "1px solid rgba(120,200,255,0.45)",
            background: busy
              ? "rgba(120,200,255,0.20)"
              : "linear-gradient(135deg, #4aa8ff, #7c6cff)",
            color: "white",
            fontWeight: 600,
            fontSize: 14,
            cursor: busy ? "wait" : "pointer",
            letterSpacing: 0.3,
            transition: "transform 120ms ease, box-shadow 120ms ease",
            boxShadow: "0 12px 30px rgba(80,120,255,0.25)",
          }}
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>

        <div
          style={{
            marginTop: 18,
            display: "flex",
            justifyContent: "space-between",
            fontSize: 12,
            color: "#778",
          }}
        >
          <button
            type="button"
            data-testid="admin-login-back"
            onClick={() => navigate("/")}
            style={{
              background: "none",
              border: "none",
              color: "#8af",
              cursor: "pointer",
              padding: 0,
              fontSize: 12,
            }}
          >
            ← back to main
          </button>
          <span>v6.0</span>
        </div>
      </form>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "11px 12px",
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.10)",
  background: "rgba(0,0,0,0.35)",
  color: "#fff",
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
};
